import React, { Component } from 'react';
import { Dialog, DialogContent, DialogTitle, Slide, Typography } from '@mui/material';

import AppBindStyles from '../../AppBindStyles';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />;
});

class AssentDialog extends Component {

    render() {
       let vendorLogo = localStorage.getItem("vendorLogo");
       if (vendorLogo) {
         localStorage.removeItem("vendorLogo");
       }


        return (
          <Dialog scroll="body"
                fullScreen
                maxWidth={false}
                open={this.props.open}
                TransitionComponent={Transition} >
            <Typography align="center">
                {!vendorLogo &&
                  <img alt="AppBind Logo" style={{marginTop: '64px'}} height="48px" src={'/logos/appbind-logo-c-b.png'} />
                }
                {vendorLogo &&
                  <img alt="Vendor Logo" style={{marginTop: '64px'}} height="48px" src={vendorLogo} />
                }
            </Typography>
            <DialogContent style={{textAlign:'center'}}>
              <div style={{width: '100%'}}>
                <div style={{maxWidth:'600px', margin: 'auto'}}>
                  <DialogTitle style={AppBindStyles.fullScreenDialogTitle}>{this.props.title}</DialogTitle>
                  {this.props.children}
                </div>
              </div>
            </DialogContent>
          </Dialog>
        );
    }
}

export default AssentDialog;
